import { Map as ImmutableMap } from 'immutable';

import { MODULE_NAME } from './constants';

export const SET_PREFER_NOT_SHOWN = `${MODULE_NAME}/SET_PREFER_NOT_SHOWN`;

export type ReduxActionType = typeof SET_PREFER_NOT_SHOWN;
export type ReduxAction = { type: ReduxActionType };

export const INITIAL_STATE = ImmutableMap({
  preferNotShown: false,
});

// eslint-disable-next-line default-param-last -- Redux reducer function signature
export const reducer = (state = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case SET_PREFER_NOT_SHOWN: {
      return state.set('preferNotShown', true);
    }
    default: {
      return state;
    }
  }
};
